import { Box } from '@chakra-ui/react';
import { FC, useRef } from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';

import LeftIcon from '@/assets/icons/ic-left.svg';
import RightIcon from '@/assets/icons/ic-right.svg';

import { OriginalsSliderButton } from '@/components/ui/features/library/OriginalsSection/components/OriginalsSliderButton';
import { OriginalsSliderItem } from '@/components/ui/features/library/OriginalsSection/components/OriginalsSliderItem';
import { OriginalsSeries } from '@/resources/OriginalsSeries';

interface IMaterialsCarouselProps {
  series: Array<OriginalsSeries>;
}

export const SLIDER_BUTTON_WIDTH = 121;

export const SeriesCarousel: FC<IMaterialsCarouselProps> = ({ series }) => {
  const swiperRef = useRef<SwiperCore>();
  const slidesPerView = 1;

  return (
    <Box position="relative" h={{ base: '342px', md: '430px', lg: '480px' }} className="slider" mb={6}>
      <OriginalsSliderButton left="0" onClick={() => swiperRef.current?.slidePrev()}>
        <LeftIcon color="white" />
      </OriginalsSliderButton>
      <Box px={{ base: 0, lg: SLIDER_BUTTON_WIDTH }}>
        <Swiper
          modules={[Autoplay]}
          loop={true}
          spaceBetween={20}
          autoplay={{ delay: 5000 }}
          slidesPerView={slidesPerView}
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {series.map((s) => (
            <SwiperSlide key={s.id}>
              <OriginalsSliderItem w="full" originals={s} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <OriginalsSliderButton right="0" top="0" onClick={() => swiperRef.current?.slideNext()}>
        <RightIcon color="white" />
      </OriginalsSliderButton>
    </Box>
  );
};
